/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { get, isEmpty } from 'lodash';
import axios from 'axios';
import PropagateLoader from 'react-spinners/PropagateLoader';
import LUSA_LOGO from '../../assets/images/main-logo.svg';
import './style.scss';
import ApplicationId from '../../components/ApplicationId';
import { newCheckInAction, newNextAction, newEsignNextAction } from '../../actions/navigation';
import easyIcon from '../../assets/images/easy.png';
import superfastIcon from '../../assets/images/super-fast.png';
import stepsIcon from '../../assets/images/steps.png';
import { parseUrlParams } from '../../utils/parseUrlParams';
import PdfViewer from './PdfViewer';
import { ricWorkflowName } from '../../utils/appConstants';

const EsignLoanDocs = (props) => {
  const { checkinData, location } = props;
  const [isChecked, setIsChecked] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPDFFullScreen, setShowPDFFullScreen] = useState(false);
  const [pageLoad, setPageLoad] = useState(true);
  const match = useParams();
  const params = parseUrlParams(window.location.search);
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = get(match, 'workflowType') === ricWorkflowName;
  const title = ricWorkFlow ? 'Retail Installment Contract' : 'Loan Documents';
  const subtitle = ricWorkFlow ? 'Contract' : 'Loan Documents';
  const navigate = useNavigate();
  const isInIframe = (window.self !== window.parent);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const base64ToArrayBuffer = (data) => {
    if (data) {
      const binaryString = window.atob(data);
      const bytes = new Uint8Array(binaryString.length);
      const arrayBuffer = bytes.map((item, idx) => binaryString.charCodeAt(idx));
      return arrayBuffer;
    }
  };

  const convertedPdfUrl = (pdfData) => {
    const type = 'PDF';
    const arrayBuffer = base64ToArrayBuffer(get(pdfData, 'data.data.loanDocument'));
    const file = new Blob([arrayBuffer], { type: `application/${type}` });
    const data = window.URL.createObjectURL(file);
    setPdfUrl(data);
    setTimeout(() => {
      setPageLoad(false);
    }, 3000);
  };

  useEffect(() => {
    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
      });
    }
    convertedPdfUrl(checkinData);
    if (!isInIframe) {
      navigate(get(checkinData, 'data.url'));
    }
  }, [checkinData]);

  const handleEsign = async () => {
    setLoading(true);
    let ipAddress;
    const ipAddressResponse = await axios.get('https://api.ipify.org?format=json&callback=?');
    if (ipAddressResponse && ipAddressResponse.data) {
      ipAddress = ipAddressResponse.data.ip;
    } else {
      ipAddress = 'static ip';
    }
    props.newEsignNextAction({
      workflowType,
      key: params.key,
      data: {
        id: get(checkinData, 'attributes.entityId'),
        error: null,
        IpAddress: ipAddress,
      },
      success: (res) => {
        if (isInIframe) {
          window.top.postMessage({ contractSigned: true }, '*');
        } else {
          navigate(get(res, 'data.url'));
        }
        setLoading(false);
      },
    });
  };

  return (
    <>
      <div className="esign-wrapper">
        <div className="esign-header">
          <img src={LUSA_LOGO} alt="Logo" />
          <div className="question-wrapper">
            <p className="question-title">Questions?</p>
            <p className="contact-no">800-994-6177</p>
          </div>
        </div>
        <div className="esign-container">
          {get(props.checkinData, 'attributes.entityId') ? (
            <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
          ) : null}
          {pageLoad
            ? (
              <div style={{ height: 350, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <PropagateLoader size={20} loading color="#3989E3" />
              </div>
            )
            : (
              <>
                <div className="page-head">
                  <h1>You're almost there! Just click and go!</h1>
                  <h4>Please electronically sign your documents</h4>
                </div>
                <div className="esign-agreement-text">
                  <p>
                    By clicking the
                    <strong> ACKNOWLEDGE </strong>
                    button below and clicking
                    <strong style={{ textTransform: 'uppercase' }}>
                      {' '}
                      ESIGN
                      {' '}
                      {subtitle}
                    </strong>
                    , you acknowledge that you have read and agree to the
                    {' '}
                    <a href={pdfUrl} target="_blank" rel="noopener noreferrer"><strong>{title}</strong></a>
                    {' '}
                    and are electronically signing every document contained therein that requires your signature.
                  </p>
                </div>
                <div className="esign-actions">
                  <button
                    type="button"
                    className={`esign-acknowledge-btn${isChecked ? ' acknowledged' : ''}`}
                    onClick={handleCheckboxChange}
                  >
                    <span className={`acknowledge-circle${isChecked ? ' checked' : ''}`}>
                      {isChecked && (
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M2.5 7L5.5 10L11.5 4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      )}
                    </span>
                    ACKNOWLEDGE
                  </button>
                  <button type="button" className="esign-btn" disabled={!isChecked || loading} onClick={handleEsign}>
                    {loading ? 'Loading....' : `ESIGN ${subtitle}`}
                  </button>
                </div>
              </>
            )}
          <div className="loan-agreement-wrapper">
            {!pageLoad
              ? (
                <div className="features">
                  <div>
                    <span><img src={easyIcon} alt="EasyIcon" /></span>
                    <p>
                      We've Made
                      <br />
                      {' '}
                      This Easy
                    </p>
                  </div>
                  <div>
                    <span><img src={superfastIcon} alt="SuperfastIcon" /></span>
                    <p>
                      Super Fast
                      <br />
                      {' '}
                      E-Sign
                    </p>
                  </div>
                  <div>
                    <span><img src={stepsIcon} alt="StepsIcon" /></span>
                    <p>
                      Here To Help
                      <br />
                      {' '}
                      At Each Step
                    </p>
                  </div>
                </div>
              )
              : <div style={{ height: 165 }} />}
            <div className="agreement">
              <div>
                <div className="agreement-header">
                  <p>{title}</p>
                  <button type="button" onClick={() => window.open(pdfUrl)}>
                    <i className="fa-solid fa-up-right-and-down-left-from-center" aria-label="open pdf" />
                  </button>
                </div>
                <div className="pdf-wrapper">
                  {pdfUrl ? <PdfViewer file={pdfUrl} /> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPDFFullScreen && (
        <div className="esign-modal">
          <div className="modal-content">
            <button className="close-btn" type="button" aria-label="close pdf" onClick={() => setShowPDFFullScreen(false)}>
              <i className="fa-solid fa-xmark" />
            </button>
            <div className="pdf-wrapper">
              {pdfUrl ? <PdfViewer file={pdfUrl} /> : null}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

EsignLoanDocs.propTypes = {
  checkinData: PropTypes.object.isRequired,
  newEsignNextAction: PropTypes.func.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  location: PropTypes.object,
};

EsignLoanDocs.defaultProps = {
  location: {},
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
  newEsignNextAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsignLoanDocs);
